import React from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import styled from "styled-components"
import { MDXRenderer } from "gatsby-plugin-mdx"

import ContentWrapper from "../styles/ContentWrapper"
import Layout from "../components/layout"
import SEO from "../components/seo"

const StyledSection = styled.section`
  width: 100%;
  max-width: 62.5rem;
  margin: 0 auto;
  padding: 0 2.5rem;
  height: auto;
  background: ${({ theme }) => theme.colors.background};
  h1 {
      font-size: 1.5rem;
  }
  h2 {
      font-size: 1.25rem;
  }
  h3 {
      font-size: 1rem;
      margin-bottom: 1rem;
  }
`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    margin: 0;
    padding: 0;
    height: 100%;
    h4 {
      font-size: 1rem;
      margin-bottom: 0.8rem;
    }
    td {
      padding: 0.2em 1.5ch;
      border-bottom: 1px solid #ddd;
    }
    .section-wrapper {
      margin: 2em 0;
      border-bottom: 1px solid #ddd;
    }
  }
`

const Service = ({ data }) => {
  // first content (position=0) includes page details
  const pageDetails = data.service.edges[0].node
  // the remaining contents are sections
  const services = data.service.edges.slice(1, data.length)
  return (
    <Layout splashScreen={false}>
      <SEO title="Services - Shigemi ISHIDA'S Portfolio" meta={[{ name: 'robots', content: 'noindex'}]} />
      <StyledSection id={pageDetails.frontmatter.title}>
        <StyledContentWrapper>
          <h1>{pageDetails.frontmatter.title}</h1>
          <MDXRenderer>{pageDetails.body}</MDXRenderer>
          {
            services.map(l => {
              const { body, frontmatter } = l.node
              return (
                <div className="section-wrapper">
                  <h2 className="section-head">{frontmatter.title}</h2>
                  <MDXRenderer>{body}</MDXRenderer>
                </div>
              )
            })
          }
        </StyledContentWrapper>
      </StyledSection>
    </Layout>
  )
}

Service.propTypes = {
  data: PropTypes.shape({
    service: PropTypes.shape({
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            body: PropTypes.string.isRequired,
            frontmatter: PropTypes.object.isRequired,
          }).isRequired,
        }).isRequired
      ).isRequired,
    }).isRequired,
  }).isRequired,
}

export default Service

export const pageQuery = graphql`
{
    service: allMdx(filter: {fileAbsolutePath: {regex: "/service/"}}, sort: {fields: [frontmatter___position], order: ASC}) {
        edges {
          node {
            body
            frontmatter {
              title
              position
            }
          }
        }
    }
}
`
